(function ($, window) {
    const qnonce = settings.nonce;

    $(document).on('click', '.quick-view-js', function () {
        window.code_happened = false;
        $.ajax({
            type: "POST",
            url: ajaxurl,
            data: {
                action: 'prodigy-quick-edit',
                post_id: $(this).data('id'),
				products_widget_id: $('.products-widget-id').val(),
				nonce: qnonce
            },
            cache: false,
            success: function (html) {
                $('#quickViewModal').on('show.bs.modal', function (event) {
                    $(this).find('.modal-body').html(html);
                });

				$('#quickViewModal').on('shown.bs.modal', function () {
					prodigyProduct.init();
					prodigyProduct.set_variant_data();

					if (!prodigyProduct.is_variants()) {
						prodigyProduct.get_master_variant_data();
					}
					prodigyProduct.set_elementor_options();
					prodigyProduct.set_product_counter();

					prodigyProduct.add_item_to_cart();
					prodigyProduct.reset_focus_to_press_enter();

					prodigyProductBulk.bulk_showing_manager();
					if (prodigyProduct.is_tiered_price) {
						prodigyProduct.get_tiered_prices_range_ajax();
					}
					prodigyProductBulk.set_bulk_variants_data();
					if (prodigyProduct.is_bulk()) {
						prodigyProduct.set_bulk();
					}

					if (prodigyProduct.is_tiered_price) {
						prodigyProduct.get_tiered_prices_range_ajax(prodigyProduct.get_master_variant_id());
						prodigyProduct.close_tiered_price_popup();
					}
				});

                $('#quickViewModal').modal('show');

                if (prodigyProduct.is_swatches()) {
                  prodigyProduct.change_swatch_value();
                }
                prodigyProduct.update_variants_dropdown();
                prodigyProduct.set_product_gallery();
                prodigyProduct.set_attribute_value_options();
            },
            error: function (jqXHR, textStatus, errorThrown) {
                console.error("AJAX Error:", textStatus, errorThrown);
                $('#quickViewModal .modal-body').text("An error occurred. Please try again.");
                $('#quickViewModal').modal('show');
            }
        });
    });
})(jQuery, window);
